<template>
    <header class="kce-site-header">
        <KceHeaderLogin />
        <div class="kce-container">
            <div class="kce-site-header__wrapper">
                <a href="/keno-certified-expert" class="kce-site-header__brand">
                    <span class="kce-site-header__brand-logo">
                        <img src="https://www.ohiolottery.com/MTLLC_Site/MTLLC_Site/ContentImages/KCE/kce-logo.png">
                    </span>
                </a>
                <button class="kce-site-header__toggle" @click="toggleMenu()">
                    <HamburgerMenu :isOpen=this.isMenuOpen></HamburgerMenu>
                </button>
            </div>
        </div>
        <KceMenu :isOpen=this.isMenuOpen></KceMenu>
    </header>
</template>
<script>

    import KceMenu from "./KceMenu.vue";
    import KceHeaderLogin from "./components/KceHeaderLogin.vue";
    import HamburgerMenu from "./components/HamburgerMenu.vue";

    export default {
        components: {
            KceMenu,
            KceHeaderLogin,
            HamburgerMenu
        },
        data: function() {
            return {
                isMenuOpen: false
            }
        },
        methods: {
            toggleMenu() {
                this.isMenuOpen = !this.isMenuOpen;
            }
        }
    }
</script>